import { RESPONSE_FAVORITES } from 'actions/constantsActions';
import {
  setProfileLastTouchFavorited,
  getProfileLastTouchFavorited,
} from 'utils/Socialization';
import { GetRegion, LOCAL_STORAGE_USERHASH } from 'constants.js';
import {
  getFavoritedList,
  addFavorited,
  deleteFavorited,
} from '../../services/favorite.service';
import {
  ADD_FAVORITE_START,
  ADD_FAVORITE_SUCCESS,
  ADD_FAVORITE_ERROR,
  DELETE_FAVORITE_START,
  DELETE_FAVORITE_SUCCESS,
  DELETE_FAVORITE_ERROR,
  API_FAVORITED_SUCCESS,
  API_FAVORITED_INIT,
} from './constants';
import { addFavContentService, deleteFavContentService, getFavoriteContentService } from 'api/services/user/favorites';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';

export const getFavorites = params => async (dispatch, getState) => {
  try {
    dispatch({ type: API_FAVORITED_INIT });
    const lasttouch = getProfileLastTouchFavorited();
    const userhash = localStorage.getItem(LOCAL_STORAGE_USERHASH);
    const live = false; // Dato se agrega en duro porque no existen carrouseles live.
    const claroLiteConfig = getClaroAdsKey(getState());

    const paramsVod = {
      ...params,
      user_hash: userhash,
      lasttouch,
      live,
      claroLiteConfig
    };

    const fetchList = await getFavoriteContentService(paramsVod).then(({ data }) => data);

    if (fetchList?.response && fetchList?.response?.groups) {
      dispatch({
        type: RESPONSE_FAVORITES,
        favorites: fetchList.response.groups,
      });
      dispatch({ type: API_FAVORITED_SUCCESS });
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  }
};

export const addToFavorites = params => async (dispatch, getState) => {
  dispatch({ type: ADD_FAVORITE_START });
  const {
    metadata: { byr_filterlist_configuration },
  } = getState();
  const region = GetRegion();
  const claroLiteConfig = getClaroAdsKey(getState());
  const filterListConfig = JSON.parse(byr_filterlist_configuration);
  const filterlist = filterListConfig[region]
    ? filterListConfig[region].filterlist
    : [];
  try {
    const response = await addFavContentService({...params, claroLiteConfig}).then(({ data }) => data);

    if (response.status === '0' || response.add) {
      if (response.lasttouch && response.lasttouch.favorited) {
        setProfileLastTouchFavorited(response.lasttouch.favorited);
      }
      dispatch(getFavorites({ user_hash: params.user_hash, filterlist }));
      dispatch({ type: ADD_FAVORITE_SUCCESS, payload: true });
    } else {
      dispatch({ type: ADD_FAVORITE_ERROR, payload: response });
    }
  } catch (e) {
    dispatch({ type: ADD_FAVORITE_ERROR, payload: e });
  }
};

export const deleteFromFavorites = params => async (dispatch, getState) => {
  dispatch({ type: DELETE_FAVORITE_START });
  const {
    metadata: { byr_filterlist_configuration },
  } = getState();
  const region = GetRegion();
  const claroLiteConfig = getClaroAdsKey(getState());
  const filterListConfig = JSON.parse(byr_filterlist_configuration);
  const filterlist = filterListConfig[region]
    ? filterListConfig[region].filterlist
    : [];
  try {
    const response = await deleteFavContentService({...params, claroLiteConfig}).then(({ data }) => data);

    if (response.status === '0' || response.delete) {
      if (response.lasttouch && response.lasttouch.favorited) {
        setProfileLastTouchFavorited(response.lasttouch.favorited);
      }
      dispatch(getFavorites({ user_hash: params.user_hash, filterlist }));
      dispatch({ type: DELETE_FAVORITE_SUCCESS, payload: true });
    } else {
      dispatch({ type: DELETE_FAVORITE_ERROR, payload: response });
    }
  } catch (e) {
    dispatch({ type: DELETE_FAVORITE_ERROR, payload: e });
  }
};
